// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global CSS Fixes for Wasted Space */

/* Slight zoom for the whole site (a little larger) */
html {
  zoom: 1.05;
}

/* Fix all container elements to use full width */
.container,
.container-fluid,
.wrapper,
.main-container,
.content-container,
.dashboard-container,
.page-container {
  max-width: 100% !important;
  width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

/* Fix table containers */
.table-container,
.table-wrapper,
.data-table-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Fix form containers */
.form-container,
.create-form-container,
.edit-form-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Fix card containers */
.card-container,
.info-card-container,
.detail-card-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Fix modal containers */
.modal-container,
.dialog-container,
.popup-container {
  max-width: 95vw !important;
  width: 95vw !important;
  margin: 0 auto !important;
}

/* Fix grid layouts */
.grid-container,
.flex-container,
.layout-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  
}

/* Fix sidebar and main content areas */
.main-content,
.content-area,
.page-content {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  
}

/* Fix specific page containers */
.create-compliance-container,
.user-management-container,
.compliance-container,
.risk-container,
.assessment-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .container,
  .container-fluid,
  .wrapper,
  .main-container,
  .content-container,
  .dashboard-container,
  .page-container,
  .table-container,
  .table-wrapper,
  .data-table-container,
  .form-container,
  .create-form-container,
  .edit-form-container,
  .card-container,
  .info-card-container,
  .detail-card-container,
  .grid-container,
  .flex-container,
  .layout-container,
  .main-content,
  .content-area,
  .page-content,
  .create-compliance-container,
  .user-management-container,
  .compliance-container,
  .risk-container,
  .assessment-container {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }
}

/* Global scrollbar styling – theme green #1f7c50 */
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 8px;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  background: transparent;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb {
  background-color: #1f7c50;
  border-radius: 9999px;
}

html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover {
  background-color: #166342;
}

/* Fallback for any scrollable element */
*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: #1f7c50;
  border-radius: 9999px;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #166342;
}

@media (max-width: 480px) {
  .container,
  .container-fluid,
  .wrapper,
  .main-container,
  .content-container,
  .dashboard-container,
  .page-container,
  .table-container,
  .table-wrapper,
  .data-table-container,
  .form-container,
  .create-form-container,
  .edit-form-container,
  .card-container,
  .info-card-container,
  .detail-card-container,
  .grid-container,
  .flex-container,
  .layout-container,
  .main-content,
  .content-area,
  .page-content,
  .create-compliance-container,
  .user-management-container,
  .compliance-container,
  .risk-container,
  .assessment-container {
    padding-left: 0.125rem !important;
    padding-right: 0.125rem !important;
  }
}

/* Override Bootstrap container classes if present */
@media (min-width: 576px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 1400px) {
  .container {
    max-width: 100% !important;
  }
}

/* ===== Table pagination – primary green ===== */
.pagination .page-link {
  color: var(--color-dark-green, #1f7c50) !important;
  background-color: #fff !important;
  border-color: rgba(31, 124, 80, 0.4) !important;
}

.pagination .page-link:hover {
  color: #fff !important;
  background-color: var(--color-dark-green, #1f7c50) !important;
  border-color: var(--color-dark-green, #1f7c50) !important;
}

.pagination .page-link:focus {
  box-shadow: 0 0 0 0.2rem rgba(31, 124, 80, 0.25) !important;
}

.pagination .page-item.active .page-link {
  color: #fff !important;
  background-color: var(--color-dark-green, #1f7c50) !important;
  border-color: var(--color-dark-green, #1f7c50) !important;
}

/* Pagination controls (custom button-style pagination) */
.pagination-controls button:not(:disabled),
.pagination-controls button.active {
  background-color: var(--color-dark-green, #1f7c50) !important;
  border-color: var(--color-dark-green, #1f7c50) !important;
  color: #fff !important;
}

.pagination-controls button:hover:not(:disabled):not(.active) {
  background-color: #196b43 !important;
  border-color: #196b43 !important;
  color: #fff !important;
}

.pagination button.active {
  background-color: var(--color-dark-green, #1f7c50) !important;
  border-color: var(--color-dark-green, #1f7c50) !important;
  color: #fff !important;
}

.pagination button:hover:not(:disabled):not(.active) {
  background-color: rgba(31, 124, 80, 0.15) !important;
  border-color: var(--color-dark-green, #1f7c50) !important;
  color: var(--color-dark-green, #1f7c50) !important;
}

/* ===== Loading / spinners – dark green (site-wide) ===== */
/* #1f7c50 = primary dark green */
.spinner-border,
.spinner-border-sm,
.spinner-border.text-primary {
  border-color: #1f7c50 !important;
  border-right-color: transparent !important;
  color: #1f7c50 !important;
}

.spinner-grow,
.spinner-grow-sm,
.spinner-grow.text-primary {
  background-color: #1f7c50 !important;
  color: #1f7c50 !important;
}

/* Generic and custom loaders */
.spinner,
.loading-spinner,
.timeline-spinner,
[class*="spinner"],
[class*="loading-spinner"] {
  border-color: rgba(31, 124, 80, 0.2) !important;
  border-top-color: #1f7c50 !important;
}

.loading-dots span,
.loading-dots span::before {
  background-color: #1f7c50 !important;
}

/* Override any blue/gray spinners in pages */
.loading-overlay .spinner,
.loading-state .spinner,
.timeline-loading .timeline-spinner,
.loading-container .loading-spinner {
  border-color: rgba(31, 124, 80, 0.2) !important;
  border-top-color: #1f7c50 !important;
}

/* Full-page / loader-container loading – dark green */
.loader-container,
.loader-container .loader-text {
  color: #1f7c50 !important;
}

.loader-container svg path,
.loader-container [class*="loader"] {
  color: #1f7c50 !important;
}

/* ===== Unified buttons – primary dark green (site-wide) ===== */
.btn-primary,
button.btn-primary,
a.btn-primary,
.btn-success.btn-primary-style {
  background-color: #1f7c50 !important;
  border-color: #1f7c50 !important;
  color: #fff !important;
}

.btn-primary:hover:not(:disabled):not(.disabled),
button.btn-primary:hover:not(:disabled):not(.disabled),
a.btn-primary:hover {
  background-color: #196b43 !important;
  border-color: #196b43 !important;
  color: #fff !important;
}

.btn-primary:focus,
.btn-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(31, 124, 80, 0.25) !important;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary.active,
.show > .btn-primary.dropdown-toggle {
  background-color: #196b43 !important;
  border-color: #165a38 !important;
  color: #fff !important;
}

/* Outline primary = dark green border/text */
.btn-outline-primary,
.btn-outline.btn-outline-primary {
  color: #1f7c50 !important;
  border-color: #1f7c50 !important;
  background-color: transparent !important;
}

.btn-outline-primary:hover:not(:disabled):not(.disabled),
.btn-outline:hover {
  background-color: rgba(31, 124, 80, 0.08) !important;
  border-color: #1f7c50 !important;
  color: #1f7c50 !important;
}

/* Professional / custom primary buttons */
.btn-primary-professional,
.btn-professional.btn-primary-professional,
.action-btn.action-btn-primary {
  background-color: #1f7c50 !important;
  border-color: #1f7c50 !important;
  color: #fff !important;
}

.btn-primary-professional:hover:not(:disabled),
.btn-professional.btn-primary-professional:hover:not(:disabled),
.action-btn-primary:hover {
  background-color: #196b43 !important;
  border-color: #196b43 !important;
  color: #fff !important;
}

/* ===== Table action column – light (like standard/references) ===== */
.table thead th:last-child,
.table tbody td:last-child,
.table th.action-column,
.table td.action-column,
.professional-table thead th:last-child,
.professional-table tbody td:last-child,
.professional-table th.action-column,
.professional-table td.action-column,
.styled-table thead th:last-child,
.styled-table tbody td:last-child {
  background-color: #f8faf9 !important;
}

.table tbody tr:hover td:last-child,
.professional-table tbody tr:hover td:last-child {
  background-color: #e8f5f0 !important;
}

/* ===== Unified table action buttons – light style (like standard) ===== */
.action-button,
.action-button-without-border,
.action-button-without-border2 {
  padding: 5px 9px !important;
  border: 1px solid transparent !important;
  border-radius: 6px !important;
  font-size: 0.8125rem !important;
  min-width: 28px !important;
  height: 28px !important;
  background-color: rgba(172, 203, 195, 0.15) !important;
  color: #3d4946 !important;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease !important;
}

.action-button:hover,
.action-button-without-border:hover {
  background-color: rgba(31, 124, 80, 0.12) !important;
  border-color: rgba(31, 124, 80, 0.4) !important;
  color: #1f7c50 !important;
}

.action-button-success,
.action-button-success:hover {
  background-color: #e8f5f0 !important;
  color: #1f7c50 !important;
  border-color: rgba(31, 124, 80, 0.3) !important;
}

.action-button-success:hover {
  background-color: #d4ede3 !important;
  border-color: #1f7c50 !important;
}

.action-button-danger,
.action-button-danger:hover {
  background-color: #fef2f2 !important;
  color: #b91c1c !important;
  border-color: #fecaca !important;
}

.action-button-danger:hover {
  background-color: #fee2e2 !important;
  border-color: #fca5a5 !important;
}

.action-button-info,
.action-button-info:hover {
  background-color: #eff6ff !important;
  color: #1d4ed8 !important;
  border-color: #bfdbfe !important;
}

.action-button-info:hover {
  background-color: #dbeafe !important;
  border-color: #93c5fd !important;
}

/* Edit / Update = warning (amber/orange) – same in all tables */
.action-btn-edit,
.action-button-edit,
.action-button-warning {
  background-color: #fef3c7 !important;
  color: #b45309 !important;
  border-color: #fcd34d !important;
}

.action-btn-edit:hover,
.action-button-edit:hover,
.action-button-warning:hover {
  background-color: #fde68a !important;
  border-color: #f59e0b !important;
  color: #92400e !important;
}

/* ===== All primary-style buttons – use primary green ===== */
.btnSubmit,
.btn-create,
.btn-review,
.renew-subscription-btn,
.renew-btn,
.add-reference-button.btn-primary {
  background-color: #1f7c50 !important;
  border-color: #1f7c50 !important;
  color: #fff !important;
}

.btnSubmit:hover:not(:disabled),
.btn-create:hover:not(:disabled),
.btn-review:hover:not(:disabled),
.renew-subscription-btn:hover:not(:disabled),
.renew-btn:hover:not(:disabled) {
  background-color: #196b43 !important;
  border-color: #196b43 !important;
  color: #fff !important;
}

.btn-refrence {
  color: #1f7c50 !important;
  border-color: #1f7c50 !important;
}

.btn-refrence:hover {
  background-color: #1f7c50 !important;
  color: #fff !important;
}

.contact-btn.btn-primary,
.contact-btn {
  background-color: #1f7c50 !important;
  border-color: #1f7c50 !important;
  color: #fff !important;
}

.contact-btn:hover {
  background-color: #196b43 !important;
  border-color: #196b43 !important;
}

/* submit-button4 = primary green (Create Asset, Bulk Create, etc.) */
.submit-button4 {
  background-color: #1f7c50 !important;
  border-color: #1f7c50 !important;
  color: #fff !important;
}

.submit-button4:hover:not(:disabled):not(.disabled) {
  background-color: #196b43 !important;
  border-color: #196b43 !important;
  color: #fff !important;
}

.submit-button4:focus {
  box-shadow: 0 0 0 0.2rem rgba(31, 124, 80, 0.25) !important;
}

/* ===== Form inputs – light background (no black/dark inputs in content) ===== */
/* Header search keeps dark style via .search-container input in Header.css (!important) */
.form-control,
.form-select {
  background-color: #fff !important;
  color: #212529 !important;
  border-color: #ced4da !important;
}

.form-control:focus,
.form-select:focus {
  background-color: #fff !important;
  color: #212529 !important;
  border-color: #1f7c50 !important;
  box-shadow: 0 0 0 0.2rem rgba(31, 124, 80, 0.15) !important;
}

.form-control::placeholder {
  color: #6c757d !important;
}

/* ===== Form labels – black on all pages (no white/light labels on light background) ===== */
/* Scoped to .main-content so login page (main-content-login) keeps its light labels on dark bg */
.main-content .form-label,
.main-content .col-form-label,
.main-content .form-group label,
.main-content .card label,
.main-content .card-body label {
  color: #212529 !important;
}

/* ===== Global scrollbars – green theme, slightly thick horizontal bar ===== */
/* All scrollbars: green thumb; horizontal bar height a little thick (8px) */
* {
  scrollbar-color: #1f7c50 #e8f0ee;
  scrollbar-width: thin;
}

*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

*::-webkit-scrollbar:horizontal {
  height: 8px;
}

*::-webkit-scrollbar-track {
  background: #e8f0ee !important;
  border-radius: 4px;
}

*::-webkit-scrollbar-thumb {
  background: #1f7c50 !important;
  border-radius: 4px;
}

*::-webkit-scrollbar-thumb:hover {
  background: #196b43 !important;
} `, "",{"version":3,"sources":["webpack://./src/styles/global-fixes.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC,qDAAqD;AACrD;EACE,UAAU;AACZ;;AAEA,iDAAiD;AACjD;;;;;;;EAOE,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;;AAEtB;;AAEA,uCAAuC;AACvC;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;;AAEtB;;AAEA,iCAAiC;AACjC;;;;;EAKE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2BE,gCAAgC;IAChC,iCAAiC;EACnC;AACF;;AAEA,mDAAmD;AACnD;;EAEE,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2BE,iCAAiC;IACjC,kCAAkC;EACpC;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,iDAAiD;AACjD;EACE,kDAAkD;EAClD,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,6DAA6D;EAC7D,yDAAyD;AAC3D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,6DAA6D;EAC7D,yDAAyD;AAC3D;;AAEA,yDAAyD;AACzD;;EAEE,6DAA6D;EAC7D,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;EACpD,yDAAyD;EACzD,kDAAkD;AACpD;;AAEA,4DAA4D;AAC5D,iCAAiC;AACjC;;;EAGE,gCAAgC;EAChC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;;;;;EAKE,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,6CAA6C;AAC7C;;;;EAIE,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA,sDAAsD;AACtD;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;;;;EAIE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;;EAEE,yBAAyB;EACzB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;EAEE,oDAAoD;EACpD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;;;;;;;;;;EAUE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,2EAA2E;AAC3E;;;EAGE,2BAA2B;EAC3B,wCAAwC;EACxC,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,sDAAsD;EACtD,yBAAyB;EACzB,0FAA0F;AAC5F;;AAEA;;EAEE,oDAAoD;EACpD,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,gEAAgE;AAChE;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;;;;;;EAME,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;;;EAKE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,qEAAqE;AACrE;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA,iFAAiF;AACjF,0FAA0F;AAC1F;;EAEE,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6FAA6F;AAC7F,iGAAiG;AACjG;;;;;EAKE,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E,4EAA4E;AAC5E;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* Global CSS Fixes for Wasted Space */\r\n\r\n/* Slight zoom for the whole site (a little larger) */\r\nhtml {\r\n  zoom: 1.05;\r\n}\r\n\r\n/* Fix all container elements to use full width */\r\n.container,\r\n.container-fluid,\r\n.wrapper,\r\n.main-container,\r\n.content-container,\r\n.dashboard-container,\r\n.page-container {\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n  margin-left: 0 !important;\r\n  margin-right: 0 !important;\r\n  padding-left: 0.5rem !important;\r\n  padding-right: 0.5rem !important;\r\n}\r\n\r\n/* Fix table containers */\r\n.table-container,\r\n.table-wrapper,\r\n.data-table-container {\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n/* Fix form containers */\r\n.form-container,\r\n.create-form-container,\r\n.edit-form-container {\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n/* Fix card containers */\r\n.card-container,\r\n.info-card-container,\r\n.detail-card-container {\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n/* Fix modal containers */\r\n.modal-container,\r\n.dialog-container,\r\n.popup-container {\r\n  max-width: 95vw !important;\r\n  width: 95vw !important;\r\n  margin: 0 auto !important;\r\n}\r\n\r\n/* Fix grid layouts */\r\n.grid-container,\r\n.flex-container,\r\n.layout-container {\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n  \r\n}\r\n\r\n/* Fix sidebar and main content areas */\r\n.main-content,\r\n.content-area,\r\n.page-content {\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n  \r\n}\r\n\r\n/* Fix specific page containers */\r\n.create-compliance-container,\r\n.user-management-container,\r\n.compliance-container,\r\n.risk-container,\r\n.assessment-container {\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .container,\r\n  .container-fluid,\r\n  .wrapper,\r\n  .main-container,\r\n  .content-container,\r\n  .dashboard-container,\r\n  .page-container,\r\n  .table-container,\r\n  .table-wrapper,\r\n  .data-table-container,\r\n  .form-container,\r\n  .create-form-container,\r\n  .edit-form-container,\r\n  .card-container,\r\n  .info-card-container,\r\n  .detail-card-container,\r\n  .grid-container,\r\n  .flex-container,\r\n  .layout-container,\r\n  .main-content,\r\n  .content-area,\r\n  .page-content,\r\n  .create-compliance-container,\r\n  .user-management-container,\r\n  .compliance-container,\r\n  .risk-container,\r\n  .assessment-container {\r\n    padding-left: 0.25rem !important;\r\n    padding-right: 0.25rem !important;\r\n  }\r\n}\r\n\r\n/* Global scrollbar styling – theme green #1f7c50 */\r\nhtml::-webkit-scrollbar,\r\nbody::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\nhtml::-webkit-scrollbar-track,\r\nbody::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\nhtml::-webkit-scrollbar-thumb,\r\nbody::-webkit-scrollbar-thumb {\r\n  background-color: #1f7c50;\r\n  border-radius: 9999px;\r\n}\r\n\r\nhtml::-webkit-scrollbar-thumb:hover,\r\nbody::-webkit-scrollbar-thumb:hover {\r\n  background-color: #166342;\r\n}\r\n\r\n/* Fallback for any scrollable element */\r\n*::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n\r\n*::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n  background-color: #1f7c50;\r\n  border-radius: 9999px;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb:hover {\r\n  background-color: #166342;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .container,\r\n  .container-fluid,\r\n  .wrapper,\r\n  .main-container,\r\n  .content-container,\r\n  .dashboard-container,\r\n  .page-container,\r\n  .table-container,\r\n  .table-wrapper,\r\n  .data-table-container,\r\n  .form-container,\r\n  .create-form-container,\r\n  .edit-form-container,\r\n  .card-container,\r\n  .info-card-container,\r\n  .detail-card-container,\r\n  .grid-container,\r\n  .flex-container,\r\n  .layout-container,\r\n  .main-content,\r\n  .content-area,\r\n  .page-content,\r\n  .create-compliance-container,\r\n  .user-management-container,\r\n  .compliance-container,\r\n  .risk-container,\r\n  .assessment-container {\r\n    padding-left: 0.125rem !important;\r\n    padding-right: 0.125rem !important;\r\n  }\r\n}\r\n\r\n/* Override Bootstrap container classes if present */\r\n@media (min-width: 576px) {\r\n  .container {\r\n    max-width: 100% !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .container {\r\n    max-width: 100% !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .container {\r\n    max-width: 100% !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .container {\r\n    max-width: 100% !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n  .container {\r\n    max-width: 100% !important;\r\n  }\r\n}\r\n\r\n/* ===== Table pagination – primary green ===== */\r\n.pagination .page-link {\r\n  color: var(--color-dark-green, #1f7c50) !important;\r\n  background-color: #fff !important;\r\n  border-color: rgba(31, 124, 80, 0.4) !important;\r\n}\r\n\r\n.pagination .page-link:hover {\r\n  color: #fff !important;\r\n  background-color: var(--color-dark-green, #1f7c50) !important;\r\n  border-color: var(--color-dark-green, #1f7c50) !important;\r\n}\r\n\r\n.pagination .page-link:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(31, 124, 80, 0.25) !important;\r\n}\r\n\r\n.pagination .page-item.active .page-link {\r\n  color: #fff !important;\r\n  background-color: var(--color-dark-green, #1f7c50) !important;\r\n  border-color: var(--color-dark-green, #1f7c50) !important;\r\n}\r\n\r\n/* Pagination controls (custom button-style pagination) */\r\n.pagination-controls button:not(:disabled),\r\n.pagination-controls button.active {\r\n  background-color: var(--color-dark-green, #1f7c50) !important;\r\n  border-color: var(--color-dark-green, #1f7c50) !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.pagination-controls button:hover:not(:disabled):not(.active) {\r\n  background-color: #196b43 !important;\r\n  border-color: #196b43 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.pagination button.active {\r\n  background-color: var(--color-dark-green, #1f7c50) !important;\r\n  border-color: var(--color-dark-green, #1f7c50) !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.pagination button:hover:not(:disabled):not(.active) {\r\n  background-color: rgba(31, 124, 80, 0.15) !important;\r\n  border-color: var(--color-dark-green, #1f7c50) !important;\r\n  color: var(--color-dark-green, #1f7c50) !important;\r\n}\r\n\r\n/* ===== Loading / spinners – dark green (site-wide) ===== */\r\n/* #1f7c50 = primary dark green */\r\n.spinner-border,\r\n.spinner-border-sm,\r\n.spinner-border.text-primary {\r\n  border-color: #1f7c50 !important;\r\n  border-right-color: transparent !important;\r\n  color: #1f7c50 !important;\r\n}\r\n\r\n.spinner-grow,\r\n.spinner-grow-sm,\r\n.spinner-grow.text-primary {\r\n  background-color: #1f7c50 !important;\r\n  color: #1f7c50 !important;\r\n}\r\n\r\n/* Generic and custom loaders */\r\n.spinner,\r\n.loading-spinner,\r\n.timeline-spinner,\r\n[class*=\"spinner\"],\r\n[class*=\"loading-spinner\"] {\r\n  border-color: rgba(31, 124, 80, 0.2) !important;\r\n  border-top-color: #1f7c50 !important;\r\n}\r\n\r\n.loading-dots span,\r\n.loading-dots span::before {\r\n  background-color: #1f7c50 !important;\r\n}\r\n\r\n/* Override any blue/gray spinners in pages */\r\n.loading-overlay .spinner,\r\n.loading-state .spinner,\r\n.timeline-loading .timeline-spinner,\r\n.loading-container .loading-spinner {\r\n  border-color: rgba(31, 124, 80, 0.2) !important;\r\n  border-top-color: #1f7c50 !important;\r\n}\r\n\r\n/* Full-page / loader-container loading – dark green */\r\n.loader-container,\r\n.loader-container .loader-text {\r\n  color: #1f7c50 !important;\r\n}\r\n\r\n.loader-container svg path,\r\n.loader-container [class*=\"loader\"] {\r\n  color: #1f7c50 !important;\r\n}\r\n\r\n/* ===== Unified buttons – primary dark green (site-wide) ===== */\r\n.btn-primary,\r\nbutton.btn-primary,\r\na.btn-primary,\r\n.btn-success.btn-primary-style {\r\n  background-color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.btn-primary:hover:not(:disabled):not(.disabled),\r\nbutton.btn-primary:hover:not(:disabled):not(.disabled),\r\na.btn-primary:hover {\r\n  background-color: #196b43 !important;\r\n  border-color: #196b43 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.btn-primary:focus,\r\n.btn-primary.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(31, 124, 80, 0.25) !important;\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled):active,\r\n.btn-primary.active,\r\n.show > .btn-primary.dropdown-toggle {\r\n  background-color: #196b43 !important;\r\n  border-color: #165a38 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n/* Outline primary = dark green border/text */\r\n.btn-outline-primary,\r\n.btn-outline.btn-outline-primary {\r\n  color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.btn-outline-primary:hover:not(:disabled):not(.disabled),\r\n.btn-outline:hover {\r\n  background-color: rgba(31, 124, 80, 0.08) !important;\r\n  border-color: #1f7c50 !important;\r\n  color: #1f7c50 !important;\r\n}\r\n\r\n/* Professional / custom primary buttons */\r\n.btn-primary-professional,\r\n.btn-professional.btn-primary-professional,\r\n.action-btn.action-btn-primary {\r\n  background-color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.btn-primary-professional:hover:not(:disabled),\r\n.btn-professional.btn-primary-professional:hover:not(:disabled),\r\n.action-btn-primary:hover {\r\n  background-color: #196b43 !important;\r\n  border-color: #196b43 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n/* ===== Table action column – light (like standard/references) ===== */\r\n.table thead th:last-child,\r\n.table tbody td:last-child,\r\n.table th.action-column,\r\n.table td.action-column,\r\n.professional-table thead th:last-child,\r\n.professional-table tbody td:last-child,\r\n.professional-table th.action-column,\r\n.professional-table td.action-column,\r\n.styled-table thead th:last-child,\r\n.styled-table tbody td:last-child {\r\n  background-color: #f8faf9 !important;\r\n}\r\n\r\n.table tbody tr:hover td:last-child,\r\n.professional-table tbody tr:hover td:last-child {\r\n  background-color: #e8f5f0 !important;\r\n}\r\n\r\n/* ===== Unified table action buttons – light style (like standard) ===== */\r\n.action-button,\r\n.action-button-without-border,\r\n.action-button-without-border2 {\r\n  padding: 5px 9px !important;\r\n  border: 1px solid transparent !important;\r\n  border-radius: 6px !important;\r\n  font-size: 0.8125rem !important;\r\n  min-width: 28px !important;\r\n  height: 28px !important;\r\n  background-color: rgba(172, 203, 195, 0.15) !important;\r\n  color: #3d4946 !important;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease !important;\r\n}\r\n\r\n.action-button:hover,\r\n.action-button-without-border:hover {\r\n  background-color: rgba(31, 124, 80, 0.12) !important;\r\n  border-color: rgba(31, 124, 80, 0.4) !important;\r\n  color: #1f7c50 !important;\r\n}\r\n\r\n.action-button-success,\r\n.action-button-success:hover {\r\n  background-color: #e8f5f0 !important;\r\n  color: #1f7c50 !important;\r\n  border-color: rgba(31, 124, 80, 0.3) !important;\r\n}\r\n\r\n.action-button-success:hover {\r\n  background-color: #d4ede3 !important;\r\n  border-color: #1f7c50 !important;\r\n}\r\n\r\n.action-button-danger,\r\n.action-button-danger:hover {\r\n  background-color: #fef2f2 !important;\r\n  color: #b91c1c !important;\r\n  border-color: #fecaca !important;\r\n}\r\n\r\n.action-button-danger:hover {\r\n  background-color: #fee2e2 !important;\r\n  border-color: #fca5a5 !important;\r\n}\r\n\r\n.action-button-info,\r\n.action-button-info:hover {\r\n  background-color: #eff6ff !important;\r\n  color: #1d4ed8 !important;\r\n  border-color: #bfdbfe !important;\r\n}\r\n\r\n.action-button-info:hover {\r\n  background-color: #dbeafe !important;\r\n  border-color: #93c5fd !important;\r\n}\r\n\r\n/* Edit / Update = warning (amber/orange) – same in all tables */\r\n.action-btn-edit,\r\n.action-button-edit,\r\n.action-button-warning {\r\n  background-color: #fef3c7 !important;\r\n  color: #b45309 !important;\r\n  border-color: #fcd34d !important;\r\n}\r\n\r\n.action-btn-edit:hover,\r\n.action-button-edit:hover,\r\n.action-button-warning:hover {\r\n  background-color: #fde68a !important;\r\n  border-color: #f59e0b !important;\r\n  color: #92400e !important;\r\n}\r\n\r\n/* ===== All primary-style buttons – use primary green ===== */\r\n.btnSubmit,\r\n.btn-create,\r\n.btn-review,\r\n.renew-subscription-btn,\r\n.renew-btn,\r\n.add-reference-button.btn-primary {\r\n  background-color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.btnSubmit:hover:not(:disabled),\r\n.btn-create:hover:not(:disabled),\r\n.btn-review:hover:not(:disabled),\r\n.renew-subscription-btn:hover:not(:disabled),\r\n.renew-btn:hover:not(:disabled) {\r\n  background-color: #196b43 !important;\r\n  border-color: #196b43 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.btn-refrence {\r\n  color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n}\r\n\r\n.btn-refrence:hover {\r\n  background-color: #1f7c50 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.contact-btn.btn-primary,\r\n.contact-btn {\r\n  background-color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.contact-btn:hover {\r\n  background-color: #196b43 !important;\r\n  border-color: #196b43 !important;\r\n}\r\n\r\n/* submit-button4 = primary green (Create Asset, Bulk Create, etc.) */\r\n.submit-button4 {\r\n  background-color: #1f7c50 !important;\r\n  border-color: #1f7c50 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.submit-button4:hover:not(:disabled):not(.disabled) {\r\n  background-color: #196b43 !important;\r\n  border-color: #196b43 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.submit-button4:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(31, 124, 80, 0.25) !important;\r\n}\r\n\r\n/* ===== Form inputs – light background (no black/dark inputs in content) ===== */\r\n/* Header search keeps dark style via .search-container input in Header.css (!important) */\r\n.form-control,\r\n.form-select {\r\n  background-color: #fff !important;\r\n  color: #212529 !important;\r\n  border-color: #ced4da !important;\r\n}\r\n\r\n.form-control:focus,\r\n.form-select:focus {\r\n  background-color: #fff !important;\r\n  color: #212529 !important;\r\n  border-color: #1f7c50 !important;\r\n  box-shadow: 0 0 0 0.2rem rgba(31, 124, 80, 0.15) !important;\r\n}\r\n\r\n.form-control::placeholder {\r\n  color: #6c757d !important;\r\n}\r\n\r\n/* ===== Form labels – black on all pages (no white/light labels on light background) ===== */\r\n/* Scoped to .main-content so login page (main-content-login) keeps its light labels on dark bg */\r\n.main-content .form-label,\r\n.main-content .col-form-label,\r\n.main-content .form-group label,\r\n.main-content .card label,\r\n.main-content .card-body label {\r\n  color: #212529 !important;\r\n}\r\n\r\n/* ===== Global scrollbars – green theme, slightly thick horizontal bar ===== */\r\n/* All scrollbars: green thumb; horizontal bar height a little thick (8px) */\r\n* {\r\n  scrollbar-color: #1f7c50 #e8f0ee;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n*::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n*::-webkit-scrollbar:horizontal {\r\n  height: 8px;\r\n}\r\n\r\n*::-webkit-scrollbar-track {\r\n  background: #e8f0ee !important;\r\n  border-radius: 4px;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n  background: #1f7c50 !important;\r\n  border-radius: 4px;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb:hover {\r\n  background: #196b43 !important;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
